// Визуальное представление 12 канонических типов вейпоинтов (types/poiTypes.ts)
// на карте - общий источник для маркеров редактора маршрутов
// (composables/useRouteEditor.ts) и для POI-пинов уже опубликованных
// маршрутов (composables/useRouteDrawing.ts::getPoiMarkerKind). До этого
// последний распознавал только 3 варианта по substring-эвристике над
// свободнотекстовым legacy poi_type - здесь она сохранена как фолбэк для
// старых GPX-импортов, а не заменена.
import type { PoiType } from "../types/poiTypes";
import warnIconUrl from "../assets/poi-icons/warn.png";
import waterIconUrl from "../assets/poi-icons/water.png";
import campIconUrl from "../assets/poi-icons/camp.png";

export interface PoiTypeMarker {
  variant: string;
  glyph: string;
  icon: string | null;
  label: string;
}

// variant подставляется в class="route-map-pin--{variant}" (styles.css) -
// только start/end/water/camp/danger/default имеют собственный цвет, поэтому
// большинство типов делят "default" (зелёный, --primary) и различаются
// глифом. Иконки (PNG) есть только для трёх типов, унаследованных от старой
// админ-панели - остальные обходятся эмодзи-глифом, без новых ассетов.
export const POI_TYPE_MARKERS: Record<PoiType, PoiTypeMarker> = {
  "night-stop": { variant: "camp", glyph: "⛺", icon: campIconUrl, label: "Ночёвка" },
  "via-point": { variant: "default", glyph: "•", icon: null, label: "Путевая точка" },
  water: { variant: "water", glyph: "💧", icon: waterIconUrl, label: "Вода" },
  danger: { variant: "danger", glyph: "⚠", icon: warnIconUrl, label: "Опасный участок" },
  viewpoint: { variant: "default", glyph: "🔭", icon: null, label: "Смотровая площадка" },
  note: { variant: "default", glyph: "📝", icon: null, label: "Заметка" },
  "rest-stop": { variant: "default", glyph: "☕", icon: null, label: "Стоянка/привал" },
  junction: { variant: "default", glyph: "⑂", icon: null, label: "Развилка" },
  shelter: { variant: "default", glyph: "🏠", icon: null, label: "Приют/укрытие" },
  parking: { variant: "default", glyph: "🅿", icon: null, label: "Парковка" },
};
